<template>
  <div
    v-if="!hideMe"
    :class="{'spl-parcel-detail-block-vertical': vertical, 'spl-parcel-detail-block-error': error, 'spl-parcel-detail-block-editing': isEditing}"
    class="spl-parcel-detail-block">
    <div class="spl-parcel-detail-block__label">
      {{ label }}
    </div>
    <div
      v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.UPDATE)"
      :class="{'spl-parcel-detail-block__edit-open': isEditing}"
      class="spl-parcel-detail-block__edit"
      @click="toggleEditable" />

    <!-- *********************** Body of the block *********************************** -->
    <div class="spl-parcel-detail-block__body">
      <!-- *********************** Block with all fields *********************************** -->
      <div
        v-for="(item, index) in blockContent"
        :key="'parcelDetailBlockContent' + index"
        :class="{'spl-parcel-detail-block__body__content-blocks': contentBlocks, 'spl-parcel-detail-block__body__content-edit': isEditing}"
        class="spl-parcel-detail-block__body__content">
        <!-- ***********************Field Labels *********************************** -->
        <div class="spl-parcel-detail-block__body__content__label">
          {{ item.field_label }}
        </div>

        <!-- *********************** Fields in View Mode *********************************** -->
        <div
          v-if="(!isEditing || !item.editable) && item.type !== 'dropdown'"
          :class="'spl-parcel-detail-block__' + item.field_key + '--value'"
          class="spl-parcel-detail-block__body__content__value spl-parcel-detail-block__body__content__value-pre">
          {{ item.value }}
        </div>
        <div
          v-if="(!isEditing || !item.editable) && item.type === 'dropdown'"
          :class="'spl-parcel-detail-block__' + item.field_key + '--value'"
          class="spl-parcel-detail-block__body__content__value spl-parcel-detail-block__body__content__value-pre">
          {{ item.label }}
        </div>

        <!-- *********************** Fields in Edit  Mode *********************************** -->
        <div v-if="isEditing && item.editable" class="spl-parcel-detail-block__body__content__value">
          <!-- *********************** Checkbox Fields  *********************************** -->
          <form-checkbox
            v-if="item.type === 'checkbox'"
            :checked="item.value"
            :index="index"
            :class="'spl-parcel-detail-block__' + item.field_key"
            name="item.field_label"
            @checkboxChanged="updateItemValue" />

          <!-- *********************** Textarea Fields *********************************** -->
          <form-textarea
            v-if="item.type === 'textarea'"
            :value="item.value"
            :index="index"
            :class="'spl-parcel-detail-block__' + item.field_key"
            @updateTextareaValue="updateItemValue" />

          <!-- *********************** Dropdown Fields  *********************************** -->
          <form-filtered-select
            v-if="item.type === 'dropdown'"
            :selected-key="item.value"
            :index="index"
            :class="'spl-parcel-detail-block__' + item.field_key"
            :options="item.options"
            @updateDropdownValue="updateItemValue" />

          <!-- *********************** Input  Fields *********************************** -->
          <form-input
            v-if="!item.type"
            :value="item.value"
            :index="index"
            :class="'spl-parcel-detail-block__' + item.field_key"
            @input="updateItemValue" />

          <!-- *********************** Dropdown Fields  *********************************** -->
          <form-input
            v-if="item.type === 'float'"
            type="float"
            :value="item.value"
            :index="index"
            :class="'spl-parcel-detail-block__' + item.field_key"
            @input="updateItemValue" />

          <!-- *********************** Date Time Fields *********************************** -->
          <form-datepicker
            v-if="item.type === 'datepicker'"
            :value="moment(item.value).toISOString(true)"
            :index="index"
            :class="'spl-parcel-detail-block__' + item.field_key"
            type="datetime"
            @input="updateItemValue" />

          <!-- *********************** Date  Fields *********************************** -->
          <form-datepicker
            v-if="item.type === 'only_datepicker'"
            :value="moment(item.value).toISOString(true)"
            :index="index"
            :class="'spl-parcel-detail-block__' + item.field_key"
            type="date"
            @input="updateItemValue" />
        </div>
      </div>

      <div v-if="isEditing" class="row">
        <div class="col6">
          <form-button
            wide="true"
            secondary="true"
            class="spl-parcel-detail-block__cancel"
            @onClick="close">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          <form-button
            :disabled="saving"
            class="spl-parcel-detail-block__save"
            wide="true"
            @onClick="save">
            Save
          </form-button>
        </div>
      </div>
    </div>
    <div v-if="highlight" class="spl-parcel-detail-block__highlight">
      {{ highlight }}
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import webApi from '@/webApi'
import constants from '@/constants'
import moment from 'moment'
export default {
  name: 'ParcelDetailBlock',
  mixins: [Helpers],
  props: [
    'label',
    'highlight',
    'error',
    'content',
    'contentBlocks',
    'vertical',
    'originalParcelJson',
    'editInProgress'
  ],
  data () {
    return {
      isEditing: false,
      tempBlockContent: this.cloneArray(this.content),
      changedValueIndices: [],
      constants,
      saving: false,
      hideMe: false,
      moment
    }
  },
  computed: {
    blockContent () {
      return this.content
    },
    parcel_json () {
      return this.originalParcelJson
    }
  },
  methods: {

    close () {
      this.isEditing = false
      this.saving = false
      window.bus.$emit('edit_in_progress')
    },
    // ************************ Toogle  Editable ************************
    // Changes to edit mode or closes it again. Edit mode is only possible if
    // not already another component is in edit mode
    toggleEditable () {
      // Close the edit mode
      if (this.isEditing) {
        this.close()
      } else {
        // Open the edit mode if not another component is in editing
        if (this.editInProgress) {
          window.bus.$emit('openWarningModal', 'You can only update one section at the same time. Please close the other one to edit here.')
        } else {
          this.isEditing = true
          window.bus.$emit('edit_in_progress')
        }
      }
    },

    updateItemValue (inputValue, index) {
      // Update the value for dropdowns, then take also the label
      this.changedValueIndices.push({ changed_index: index })
      if (inputValue.label) {
        this.$set(this.tempBlockContent[index], 'label', inputValue.label)
        this.$set(this.tempBlockContent[index], 'value', inputValue.value)
      } else {
        // Input fields we take the value 1:1
        this.$set(this.tempBlockContent[index], 'value', inputValue)
      }
    },

    // Checks which fields were updated and
    save () {
      // Disable the button while saving
      this.saving = true
      // Check if something was changed
      this.get_Changed_Parcel(this,
        // Success function which returns if something was changed and updated parcel_json
        function (context, parcelUpdated, tempParcelJson) {
          // Check if an update happend
          if (parcelUpdated) {
            // call update parcel web API
            // Call the api and pass the filtered columns and values
            webApi.parcel.update_Parcel(tempParcelJson).then((response) => {
              // Parcel was succesfully updated so we update the blockContent
              context.changedValueIndices.forEach(item => {
                if (context.tempBlockContent[item.changed_index].label) {
                  context.$set(context.blockContent[item.changed_index], 'label', context.tempBlockContent[item.changed_index].label)
                }
                context.$set(context.blockContent[item.changed_index], 'value', context.tempBlockContent[item.changed_index].value)
              })
              context.$toast('The parcel got updated with your changes', constants.defaultToastOptions())
              context.$emit('parcelUpdated')
              context.isEditing = false
              context.saving = false
              window.bus.$emit('edit_in_progress')
            }).catch((response) => {
              window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
              context.saving = false
            })
            // update the modal with the new information
          } else {
            // Nothing was changed, so throw a warning

            window.bus.$emit('openWarningModal', "Didn't you forget something? Nothing was changed.")
            context.saving = false
          }
        },
        function () {
          window.bus.$emit('openErrorModal', 'Please try again.')
          this.saving = false
        })
    },

    // Checks if something was changed  in the block and returns updated parcel_json
    get_Changed_Parcel (context, successFunction, errorFunction) {
      // Copy the parcel
      var tempParcelJson = context.cloneArray(context.parcel_json)
      // Loop the content to get all changed fields
      let parcelUpdated = false

      context.tempBlockContent.forEach(item => {
        var compareDate
        // Check for  all labels
        switch (item.field_label) {
          case constants.PARCEL_FIELD_LABELS.COUNTRY:
            if (item.value !== tempParcelJson.Country_ID) {
              parcelUpdated = true
              tempParcelJson.Country_ID = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.CUSTOMER:
            if (item.value !== tempParcelJson.Customer_ID) {
              parcelUpdated = true
              tempParcelJson.Customer_ID = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.DANGEROUS_GOODS:
            if (item.value !== tempParcelJson.Dangerous_Goods) {
              parcelUpdated = true
              tempParcelJson.Dangerous_Goods = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.XRAYED:
            if (item.value !== tempParcelJson.XRayed) {
              parcelUpdated = true
              tempParcelJson.XRayed = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.Last_Mile_Upgrade:
            if (item.value !== tempParcelJson.Last_Mile_Upgrade) {
              parcelUpdated = true
              tempParcelJson.Last_Mile_Upgrade = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.SERVICE_LEVEL:
            if (item.value !== tempParcelJson.Service_Level_ID) {
              parcelUpdated = true
              tempParcelJson.Service_Level_ID = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.OPEN_DEADLINE:
            item.value = this.formatDate(item.value, true, 'YYYY-MM-DD HH:mm')
            compareDate = this.formatDate(tempParcelJson.Open_Deadline, true, 'YYYY-MM-DD HH:mm')
            if (item.value !== compareDate) {
              parcelUpdated = true
              tempParcelJson.Open_Deadline = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.CLOSE_DEADLINE:
            item.value = this.formatDate(item.value, true, 'YYYY-MM-DD HH:mm')
            compareDate = this.formatDate(tempParcelJson.Close_Deadline, true, 'YYYY-MM-DD HH:mm')
            if (item.value !== compareDate) {
              parcelUpdated = true
              tempParcelJson.Close_Deadline = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.LENGTH:
            if (item.value !== tempParcelJson.Length) {
              parcelUpdated = true
              tempParcelJson.Length = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.WIDTH:
            if (item.value !== tempParcelJson.Width) {
              parcelUpdated = true
              tempParcelJson.Width = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.HEIGHT:
            if (item.value !== tempParcelJson.Height) {
              parcelUpdated = true
              tempParcelJson.Height = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.VOLUME:
            if (item.value !== tempParcelJson.Volume) {
              parcelUpdated = true
              tempParcelJson.Volume = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.WEIGHT:
            if (item.value !== tempParcelJson.Weight) {
              parcelUpdated = true
              tempParcelJson.Weight = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.BOOKED_PICKUP_DATE:
            item.value = this.formatDate(item.value, false, 'YYYY-MM-DD')
            compareDate = this.formatDate(tempParcelJson.Booked_Pickup_Date, false, 'YYYY-MM-DD')
            if (item.value !== compareDate) {
              parcelUpdated = true
              tempParcelJson.Booked_Pickup_Date = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.PICKUP_TIME:
            if (item.value !== tempParcelJson.Pickup_Timestamp) {
              parcelUpdated = true
              tempParcelJson.Pickup_Timestamp = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.DELIVERY_TIME:
            if (item.value !== tempParcelJson.Delivery_Timestamp) {
              parcelUpdated = true
              tempParcelJson.Delivery_Timestamp = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.ENGINEER_PICKUP_TIME:
            if (item.value !== tempParcelJson.Engineer_Pickup) {
              parcelUpdated = true
              tempParcelJson.Engineer_Pickup = item.value
            }
            break
          case constants.PARCEL_FIELD_LABELS.CURRENT_LOCATION:
            if (item.id !== tempParcelJson.Current_Status_Event_ID) {
              parcelUpdated = true
              tempParcelJson.Current_Status_Event_ID = item.id
            }
            break
        }
      })
      // Return the succes function
      successFunction(context, parcelUpdated, tempParcelJson)
    }

  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-detail-block {
        background-color: $parcelTimelineBackgroundColor;
        margin-bottom: 20px;
        padding: 20px 17px 30px 17px;
        position: relative;
        width: 100%;

        &-editing {
          background-color: $parcelTimelineBackgroundColorEditing !important;
        }

        @include mobile() {
            padding-bottom: 20px;
        }
        &-error {
            background-color: $redBackgroundLight;
            border-left: 2px solid $red;

            .spl-parcel-detail-block__edit {
                background-image: url(../../assets/icon-tripple-dot-red.svg);

            }
        }
        &-error &__edit {
            &-open {
                background-image: url(../../assets/icon-close-red.svg);
            }
        }
        &-vertical {
            &:after {
                clear: both;
                content: '';
                display: block;
                float: none;
            }
            .spl-parcel-detail-block {
                &__label,
                &__body {
                    float: left;
                    min-height: 10px;
                    vertical-align: top;
                }
                &__label {
                    width: 16.6667%;

                    @include mobile() {
                        width: 100%;
                    }
                }
                &__body {
                    width: 41.6667%;

                    @include mobile() {
                        width: 100%;
                    }
                }
            }
        }
        &__edit {
            background-image: url(../../assets/icon-tripple-dot.svg);
            background-position: center center;
            background-repeat: no-repeat;
            cursor: pointer;
            height: 25px;
            position: absolute;
            right: 10px;
            top: 20px;
            transition: opacity $shortTransition ease-in-out;
            width: 25px;

            &:hover {
                opacity: 0.5;
            }
            &-open {
                background-image: url(../../assets/icon-close.svg);
            }
        }
        &__label {
            color: $mainInputColor;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 15px;
        }
        &__body {
            .spl-button,
            .spl-textarea,
            .spl-dropdown {
                margin: 0 0 10px 0;
            }
            &__content {
                font-size: 12px;
                line-height: 1.7;

                &:after {
                    clear: both;
                    content: '';
                    display: block;
                    float: none;
                }
                &-blocks,
                &-edit {
                    margin-bottom: -20px;

                    .spl-parcel-detail-block__body__content {
                        &__label,
                        &__value {
                            width: 100%;
                        }
                        &__value {
                            margin-bottom: 220px;
                        }
                    }
                }
                &-edit .spl-parcel-detail-block__body__content {
                    &__label {
                        color: $parcelDetailBlockLabelColor;
                        font-family: $mono;
                        font-size: 9px;
                        font-weight: 700;
                        line-height: 12px;
                        letter-spacing: 1px;
                        margin-bottom: 10px;
                        text-transform: uppercase;
                    }
                    &__value {
                        .spl-input {
                            margin-bottom: 10px;
                        }
                    }
                }
                &__label,
                &__value {
                    float: left;
                    min-height: 10px;
                    vertical-align: top;
                    width: 50%;

                    @include mobile() {
                        width: 100%;
                    }
                }
                &__value {
                    font-weight: 600;

                    &-pre {
                        white-space: pre;
                    }
                    @include mobile() {
                        margin-bottom: 10px;
                    }
                }
            }
        }
        &__function-button {
            color: $middleYellow;
            cursor: pointer;
            display: inline-block;
            font-size: 12px;
            font-weight: 600;
            margin-right: 20px;
            transition: color $shortTransition ease-in-out;

            @include mobile() {
                margin-right: 10px;
            }
            &:hover {
                color: $yellowButtonLabelHover;
            }
        }
        &__highlight {
            background-color: $tableRowBackgroundColorSelected;
            border-left: 2px solid $middleYellow;
            bottom: 0;
            color: $mainInputColor;
            font-size: 12px;
            font-weight: 400;
            margin: 30px -17px -30px -17px;
            padding: 15px;
        }
    }
</style>
